export default __webpack_public_path__ + "static/media/ALLdemos.7fe4ae49.jpg";